<script lang="ts">
    import { Col, Image, Row } from "sveltestrap";
    import Card from "../../../Core/Card.svelte";
    import Carousel from 'svelte-carousel';
    import data from "../../../../Data/Ecommerce/Ecommerce.json"
    import ProductThumbnail from "./ProductThumbnail.svelte";
    let carousel:any;
    let imgPath:string = "/assets/images/ecommerce"
</script>
<Col xl="5" md="6" class="box-col-12 xl-50">
    <Card>
      <div slot="contentbody">
        <Row>
            <Col xl="9" class="product-main">
                <div class="product-slider owl-carousel owl-theme" id="sync1">
                    <Carousel bind:this={carousel} particlesToShow={1} particlesToScroll={1} arrows={false} autoplay autoplayDuration={2000} dots={false}>
                        {#each data.productpageimgdata as productItem }
                            <div class="item">
                                <Image src="{imgPath}/{productItem.img}"/>
                            </div>
                        {/each}
                    </Carousel>
                </div>
            </Col>
            <ProductThumbnail />
        </Row>
      </div>
    </Card>
</Col>
